import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-field-error-display',
  templateUrl: './field-error-display.component.html',
  styleUrls: ['./field-error-display.component.css']
})
export class FieldErrorDisplayComponent implements OnInit {
  constructor() { }
  ngOnInit() {
    if (!this.errorMsg) {
      if (this.Field === "ForBankBranch") {
        this.errorMsg = "ไม่พบข้อมูล Bank/Branch กรุณาตรวจสอบข้อมูล Vendor ใหม่อีกครั้ง";
      }
      else if (this.Field) {
        this.errorMsg = "Please Specify " + this.Field;
      }
    }
  }
  @Input() errorMsg: string;
  @Input() Pad_Right_Custom: string;
  @Input() Field: string;
  @Input() displayError: boolean;
  @Input() CtrlType: string;

  GetClassByCtrl() {
    let Class = "";
    switch (this.CtrlType) {
      case "atc":
        Class = "fa fa-times form-control-feedback form-control-feedback-autocomplete";
        break;
      default:
        Class = "fa fa-times form-control-feedback";
        break;
    }
    return Class;
  }
}
